import { platformSource } from '@/utils/platformMigrationHelper';

export default {
  data() {
    return {
      iframeSource: null,
    };
  },
  methods: {
    /**
     * Detects if the page is loaded inside an iframe based on localStorage
     * Sets this.isIframe to true if iframe-view.closeCta is true
     */
    detectIframe() {
      const iframeView = localStorage.getItem('iframe-view');
      try {
        const closeCta = iframeView && iframeView.length ? JSON.parse(iframeView) : null;
        this.iframeSource = platformSource();
        this.isIframe = closeCta && closeCta.closeCta === true;
      } catch (e) {
        this.isIframe = false;
      }

      // Close sidebar if in iframe
      if (this.isIframe) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false);
      }
    },
    /**
     * Shows the sidebar if not in iframe mode
     */
    showSidebar() {
      if (this.isIframe) return;
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);
    },
  },
};

